import React from 'react'

import { 
	TextField, FormControl, InputLabel, Select, MenuItem,
	Card, CardContent, CardActions, Typography,
	Dialog, Button
} from '@material-ui/core'

export default class MultipleChoice extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			variants: this.props.data || [ '', '' ]
		}
	}

	setData(data) {
		this.setState({
			variants: data
		})
	}

	getData() {
		return this.state.variants
	}

	addRow() {
		let variants = this.state.variants
		variants.push('')

		this.setState({
			variants: variants
		})
	}

	removeRow(i) {
		let variants = this.state.variants
		variants.splice(i, 1)

		this.setState({
			variants: variants
		})
	}


	handleChange(i, e) {
		let variants = this.state.variants
		variants[i] = e.target.value

		this.setState({
			variants: variants
		})
	}

	renderRow(r, i) {
		if (r == null) {
			return <>
				<br/>
				<Button disabled={this.props.disabled} onClick={this.addRow.bind(this)} variant="contained" color="primary">ADD VARIANT</Button>
				<br/>
				<br/>
				<hr/>
			</>
		}

		return <>
			<TextField disabled={this.props.disabled} style={{ marginBottom: '5px', marginRight: '25px' }} value={r} onChange={this.handleChange.bind(this, i)} variant="outlined" placeholder={"Option #" + (i + 1)}/>
			{ i != 0 && <Button onClick={this.removeRow.bind(this, i)} disabled={this.props.disabled} variant="contained" style={{ marginTop: '10px' }}>remove</Button> }
			<br/>
		</>
	}

	render() {
		let rows = this.state.variants.slice(0)

		if (rows.length < 4) {
			rows.push(null)
		}

		return <>
			{ rows.map((r, i) => this.renderRow(r, i)) }
		</>
	}
}